import { SpeakersPaletteTokens, Typography } from '@braskai/ui-kit';

import { Stack, StackProps } from '@mui/material';

import { TeamspaceAvatar } from '../TeamspaceAvatar';

type TeamspaceMenuItemProps = {
  name: string;
  color?: SpeakersPaletteTokens;
  dataTestId?: string;

  disabled?: boolean;
  hover?: boolean;
  isActive?: boolean;
  isError?: boolean;
  isLabel?: boolean;
  isMobile?: boolean;
  isOpenSidebar?: boolean;
  isOwner?: boolean;
  membersCount?: number;
  size?: 'lg' | 'md';
} & StackProps;

const getColorDescription = (disabled?: boolean, isError?: boolean) => {
  if (disabled) {
    return 'grey.400';
  }

  if (isError) {
    return 'error.700';
  }

  return 'grey.500';
};

const getWidthLabel = (isLabel: boolean, isMobile: boolean) => {
  if (isMobile && isLabel) return '170px';

  if (isMobile) return '180px';

  if (isLabel) return '119px';

  return '116px';
};

export const TeamspaceMenuItem = ({
  name,
  color,
  dataTestId,
  disabled,
  hover = false,
  isActive = false,
  isError,
  isLabel = false,
  isMobile = false,
  isOpenSidebar = true,
  isOwner,
  membersCount,
  size = 'md',
  ...props
}: TeamspaceMenuItemProps) => {
  const isLarge = size === 'lg';
  const colorTitle = hover ? 'grey.900' : 'grey.700';
  const widthContent = isMobile ? 'calc(100% - 32px)' : '100%';

  return (
    <Stack
      sx={{
        overflow: isMobile ? 'hidden' : undefined,
        width: '100%',
      }}
      alignItems="center"
      data-testid={dataTestId}
      direction="row"
      gap={8}
      width="100%"
      {...props}
    >
      <TeamspaceAvatar
        name={name}
        color={color}
        disabled={disabled || isError}
        isActive={isActive || hover}
        size={isMobile ? 'sm' : size}
      />
      <Stack
        sx={{
          width: isOpenSidebar ? widthContent : 0,
        }}
        alignItems={isLabel && isMobile ? 'center' : undefined}
        direction={isLabel && isMobile ? 'row' : 'column'}
        gap={isLabel && isMobile ? 4 : undefined}
        justifyContent={isLabel && isMobile ? 'space-between' : undefined}
      >
        <Typography
          sx={{
            transition: 'color 0.2s',
            width: getWidthLabel(isLabel, isMobile),
          }}
          color={disabled ? 'grey.400' : colorTitle}
          maxLines={1}
          variant={isLarge ? 'body-2-md' : 'caption-1-md'}
        >
          {name}
        </Typography>

        <Typography
          color={getColorDescription(disabled, isError)}
          maxLines={isMobile ? undefined : 1}
          variant={isLarge ? 'caption-1' : 'caption-2'}
        >
          {isOwner ? `Owner${membersCount ? `, ${membersCount} members` : ''}` : 'Editor'}
        </Typography>
      </Stack>
    </Stack>
  );
};
